export function XtBody(props) {
        return (<div className="p-3"> {props.children}</div>);
}



